var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-0 pt-3 pb-3 border-bottom",attrs:{"id":"nav"}},[_c('h3',[_vm._v("Flights")]),_c('router-link',{attrs:{"to":"/flights"}},[_vm._v("Live")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }